module.exports = __webpack_public_path__ + "static/media/infomex.ff9ed844.jpg";